export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-background-50"></i>
                </div>
                <span className="text-xl font-bold font-heading text-background-50">
                  丫丫影院
                </span>
              </a>
              <p className="text-sm text-background-400 leading-relaxed mb-4">
                丫丫影院提供最新电影和电视剧资源，播放不缓冲，流畅观看，高清免费在线看。每日更新海量影视内容，为您带来极致的在线观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors">
                  <i className="ri-wechat-line text-sm text-background-200"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors">
                  <i className="ri-weibo-line text-sm text-background-200"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors">
                  <i className="ri-bilibili-line text-sm text-background-200"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
              <nav className="flex flex-col gap-2.5">
                <a href="#carousel" className="text-sm text-background-400 hover:text-background-200 transition-colors">焦点专题</a>
                <a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">影视分类</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors">热门排行</a>
                <a href="#media" className="text-sm text-background-400 hover:text-background-200 transition-colors">精彩推荐</a>
                <a href="#cards" className="text-sm text-background-400 hover:text-background-200 transition-colors">精选推荐</a>
              </nav>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">服务支持</h3>
              <nav className="flex flex-col gap-2.5">
                <a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors">常见问答</a>
                <a href="#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors">联系投稿</a>
                <a href="#updates" className="text-sm text-background-400 hover:text-background-200 transition-colors">更新动态</a>
                <a href="#app" className="text-sm text-background-400 hover:text-background-200 transition-colors">移动端入口</a>
              </nav>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500">
                更多合作伙伴即将加入，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 丫丫影院 - 最新电影不缓冲 · 最新电视剧流畅在线看
            </p>
            <p className="text-xs text-background-600">
              本站所有内容仅供交流学习，请支持正版
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}